<breadcrumb #parent>
    <section class="breadcrumb-area">
        <div class="container">
            <div class="section-internal">
                <div class="section-particle-effect d-none d-md-block section-particle-effect-v3">
                    <img class="particle-1 animate-zoom-fade" src="assets/img/particle/particle-1.png"
                        alt="particle One">
                    <img class="particle-2 animate-rotate-me" src="assets/img/particle/particle-2.png"
                        alt="particle Two">
                    <img class="particle-3 animate-float-bob-x" src="assets/img/particle/particle-3.png"
                        alt="particle Three">
                    <img class="particle-4 animate-float-bob-y" src="assets/img/particle/particle-4.png"
                        alt="particle Four">
                    <img class="particle-5 animate-float-bob-y" src="assets/img/particle/particle-5.png"
                        alt="particle Five">
                </div>
                <div class="row align-items-center">
                    <div class="col-12">
                        <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
                            <div class="breadcrumb-content text-center">
                                <div class="page-title wow fadeInDown" data-wow-delay="0.1s" data-wow-duration="1500ms">
                                    <h1>{{ route.displayName }}</h1>
                                </div>
                                <div class="page-breadcrumb wow fadeInUp" data-wow-delay="0.2s"
                                    data-wow-duration="1500ms">
                                    <ul class="breadcrumb">
                                        <li><a routerLink="/">Home</a></li>
                                        <li class="active">{{ route.displayName }}</li>
                                    </ul>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div> <!-- /.row -->
            </div> <!-- /.section-internal -->
        </div> <!-- /.container -->
    </section>
</breadcrumb>